function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6730",
  d: "M0 18.827h4.667a1.014 1.014 0 01.436.098l16.485 7.884a3.38 3.38 0 002.599.145l26.305-9.148a3.112 3.112 0 00-1.791-5.958l-17.026 4.265a.994.994 0 01-.243.03h-6.83a9.533 9.533 0 00-6.16 2.258 1.014 1.014 0 11-1.305-1.538 11.55 11.55 0 017.462-2.737h4.636a3.991 3.991 0 003.971-3.984 3.947 3.947 0 00-3.947-3.934h-9.243a1.014 1.014 0 01-.676-.257L12.673 0H0z",
  fill: "currentColor"
});
var SvgHandUp = function SvgHandUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.607 27.147"
  }, props), _ref);
};
export default SvgHandUp;